<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    {{
                      getLabel(
                        getDashboardRole.code,
                        $dd_verifier,
                        "Dealer Pending Top-up Verification",
                        "Dealer Pending Top-up Approval"
                      )
                    }}
                  </v-toolbar-title>
                </div>
                <!-- <div class="ml-auto">
                  <v-btn color="primary" @click="addIbasUser()">
                    <v-icon class="mr-2">mdi-plus</v-icon> Add
                  </v-btn>
                </div> -->
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            item-key="id"
            :search="search"
            loading-text="Loading... Please wait"
            class="elevation-1"
          >
            <template
              v-for="header in table.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                x-small
                color="primary"
                class="mr-2"
                dark
                @click="verify(item)"
              >
                {{
                  getLabel(
                    getDashboardRole.code,
                    $dd_verifier,
                    "Verify",
                    "Approve"
                  )
                }}</v-btn
              >

              <v-btn x-small color="pink" dark @click="deny(item)"> Deny</v-btn>
            </template>

            <template v-slot:[`item.image`]="{ item }">
              <a href="#" @click.prevent="viewImage(item)">View Image</a>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <ConfirmationDiaglog ref="confirm" />
    <Snackbar />
  </v-container>
</template>

<script>
// import moment from "moment";
import ShareableMethods from "@/mixins/ShareableMethods";
import ConfirmationDiaglog from "../dialogs/ConfirmationDiaglogv2.vue";
import Snackbar from "../dialogs/Snackbar.vue";
export default {
  mixins: [ShareableMethods],
  name: "TopupHistory",
  components: {
    ConfirmationDiaglog,
    Snackbar,
  },
  data() {
    return {
      selectedImage: [],

      search: "",
      table: {
        // sortBy: "dtCreated",
        sortDesc: true,
        loading: false,
        headers: [
          {
            text: "Dealer",
            align: "start",
            value: "companyName",
          },
          {
            text: "Date Requested",
            // align: "center",
            value: "transactionDate",
            // formatter: (x) => (x ? this.formatDate(x) : null),
          },

          {
            text: "Amount",
            align: "center",
            value: "amount",
            sortable: false,
            formatter: (x) => (x ? this.setToLocaleString(x) : 0),
          },
          {
            text: "Bank Name",
            // align: "center",
            value: "bankName",
            sortable: false,
          },

          {
            text: "Account Name",
            // align: "center",
            value: "accountName",
            sortable: false,
          },

          {
            text: "Proof of Payment",
            // align: "center",
            value: "image",
            sortable: false,
            align: "center",
          },

          {
            text: "Actions",
            // align: "center",
            value: "actions",
            sortable: false,
          },
        ],
        data: [],
      },
      DID: {
        distributorId: "",
      },
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    async getList() {
      this.table.loading = true;
      const { adminLogin } = this.userData;
      const endPoint = this.getLabel(
        this.getDashboardRole.code,
        this.$dd_verifier,
        "verification-dealer-topups",
        "approval-dealer-topups"
      );

      await this.$drs
        .get(
          `/broker/drs/${endPoint}?distributorId=${adminLogin.distributorId}`
        )
        .then((response) => {
          const newArr = response.data;
          console.log(newArr.data.list);
          this.table.data = newArr.data.list;
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    async verify(item) {
      if (
        await this.$refs.confirm.open(
          "Verify",
          "Are you sure you want to proceed?"
        )
      ) {
        const payload = {
          referenceNo: item.referenceNo,
          amount: item.amount,
          transactionDate: item.transactionDate,
        };

        payload[
          this.getLabel(
            this.getDashboardRole.code,
            this.$dd_verifier,
            "verifiedBy",
            "approvedBy"
          )
        ] = this.userData.adminLogin.name;

        const endPoint = this.getLabel(
          this.getDashboardRole.code,
          this.$dd_verifier,
          "verify-dealer-topups",
          "approve-dealer-topups"
        );

        await this.$drs
          .post(`/broker/drs/${endPoint}`, payload)
          .then((response) => {
            const res = response.data;

            this.$store.dispatch("addSnackbarMessage", res.message);
            this.$store.dispatch("addSnackbar", true);

            if (res.status) {
              this.getList();
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },

    async deny(item) {
      if (
        await this.$refs.confirm.open(
          "Deny",
          "Are you sure you want to proceed?"
        )
      ) {
        const payload = {
          referenceNo: item.referenceNo,
          amount: item.amount,
          transactionDate: item.transactionDate,
          declineBy: this.userData.adminLogin.name,
        };

        await this.$drs
          .post("/broker/drs/decline-topups", payload)
          .then((response) => {
            const res = response.data;

            this.$store.dispatch("addSnackbarMessage", res.message);
            this.$store.dispatch("addSnackbar", true);

            if (res.status) {
              this.getList();
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },

    viewImage(item) {
      if (item.image) {
        this.selectedImage.push(item.image);
        this.$viewerApi({
          images: ["data:image/png;base64," + this.selectedImage],
        });
        return;
      }

      this.$store.dispatch("addSnackbarMessage", "No Image");
      this.$store.dispatch("addSnackbar", true);
    },
  },
  created() {
    this.getList();
    // console.log(this.$props.headers);
  },

  watch: {
    // reload(val) {
    //   this.getDrawList(val);
    // },
  },

  computed: {
    userData() {
      return this.$store.getters.userData;
    },

    getDashboardRole() {
      return this.$store.getters.dashboardRole;
    },
  },
};
</script>
